"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaProfessor = exports.yupProfessor = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
const utils_1 = require("../utils");
const estado_1 = require("./estado");
exports.yupProfessor = yup.object({
    idEmpresa: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Empresa'),
    nome: yup.string().default('').max(50).required().label('Nome'),
    sexo: yup.mixed().oneOf(Object.values(enums_1.ESexo)).required().default(enums_1.ESexo.Feminino).label('Sexo'),
    dataNascimento: (0, utils_1.sge2Date)().default(null).nullable().label('Data Nascimento'),
    naturalidade: yup.string().default('').max(40).label('Naturalidade'),
    estadoNaturalidade: yup
        .string()
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(estado_1.estado[0].sigla)
        .label('Estado Naturalidade'),
    cpf: yup.string().default('').max(15).required().label('Cpf'),
    rg: yup.string().default('').max(15).required().label('Rg'),
    nomePai: yup.string().default('').max(50).label('Nome do Pai'),
    nomeMae: yup.string().default('').max(50).label('Nome da Mãe'),
    professor: yup.boolean().required().default(false).label('Professor'),
    email: yup.string().default('').email().max(60).required().label('Email'),
    login: yup.string().default('').max(30).required().label('Login'),
    senha: yup.string().max(15, 'Máximo de 15 caracteres.').notRequired().label('Senha'),
    estadoCivil: yup.string().oneOf(Object.keys(enums_1.EEstadoCivil)).default('Não Informado').label('Estado Civil'),
    nomeConjuge: yup.string().default('').max(60).label('Nome Conjuge'),
    trabalhoConjuge: yup.string().default('').max(30).label('Trabalho Conjuge'),
    telefoneConjuge: yup.string().default('').max(15).label('Telefone Conjuge'),
    endereco: yup.string().default('').max(40).label('Endereco'),
    numero: yup.string().default('').max(8).label('Numero'),
    complemento: yup.string().default('').max(20).label('Complemento'),
    bairro: yup.string().default('').max(30).label('Bairro'),
    cidade: yup.string().default('').max(30).label('Cidade'),
    estado: yup
        .string()
        .oneOf(estado_1.estado.map((m) => m.sigla))
        .default(estado_1.estado[0].sigla)
        .label('Estado'),
    cep: yup.string().default('').max(10).label('Cep'),
    telefone: yup.string().default('').max(15).label('Telefone'),
    celular: yup.string().default('').max(15).label('Celular'),
    funcao: yup
        .string()
        .oneOf([...(0, enums_1.enumKeys)(enums_1.EProfissao), ''])
        .default('')
        .label('Função'),
    area: yup.string().default('').max(100).label('Area de Atuação'),
    ctps: yup.string().default('').max(10).label('Ctps'),
    ctpsSerie: yup.string().default('').max(10).label('Ctps Serie'),
    ctpsEstado: yup
        .string()
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(estado_1.estado[0].sigla)
        .label('Ctps Estado'),
    ctpsData: (0, utils_1.sge2Date)().default(null).nullable().label('Ctps Data'),
    pis: yup.string().default('').max(15, 'Máximo de 15 caracteres.').label('Pis'),
    dataEntrada: (0, utils_1.sge2Date)().default(null).nullable().label('Data Admissão'),
    dataSaida: (0, utils_1.sge2Date)().default(null).nullable().label('Data Demissao'),
    escolaridade: yup.string().default('').label('Escolaridade'),
    entregue: yup.boolean().required().default(false).label('Entregou os Documentos'),
    etiqueta: yup.boolean().required().default(false).label('Etiqueta'),
    cargaHoraria: yup.number().default(0).label('Carga Horaria Diaria'),
    horaSemanal: yup.number().default(0).label('Carga Horaria Semanal'),
    auxiliarInfantil: yup.boolean().required().default(false).label('Auxiliar Infantil'),
    certidaoTipo: yup.string().default('').max(1).label('Tipo Certidão'),
    certidaoNumero: yup.string().default('').max(100).label('Numero Certidão'),
    certidaoLivro: yup.string().default('').max(8).label('Livro Certidão'),
    certidaoFolha: yup.string().default('').max(6).label('Folha Certidão'),
    certidaoCartorio: yup.string().default('').max(40).label('Cartorio Certidão'),
    certidaoCidade: yup.string().default('').max(40).label('Cidade Certidão'),
    certidaoEstado: yup
        .string()
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default(estado_1.estado[0].sigla)
        .label('Estado Certidão'),
    certidaoData: (0, utils_1.sge2Date)().default(null).nullable().label('Certidão Data'),
    raca: yup.mixed().default(enums_1.ERaca['0 - Sem declaração']).label('Raça'),
    religiao: yup.string().default('').max(20).label('Religião'),
    posEspecializacao: yup.boolean().required().default(false).label('Posssui Especialização'),
    posMestrado: yup.boolean().required().default(false).label('Possui Mestrado'),
    posDoutorado: yup.boolean().required().default(false).label('Possui Doutorado'),
    moduloProfessor: yup.number().default(null).nullable().label('Modulo Professor'),
    observacao: yup.string().default('').max(600).label('Observação'),
    idImagem: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Imagem Professor'),
});
exports.schemaProfessor = exports.yupProfessor.shape({});
